"use strict";

require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.for-each.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _phaser = require("phaser");
var _PreloadScene = _interopRequireDefault(require("./scenes/PreloadScene"));
var _GameScene = require("./scenes/GameScene");
var _bootScene = require("./scenes/boot-scene");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import PlayScene from "./scenes/PlayScene";
const config = {
  // type: Phaser.AUTO,
  // scale: {
  // mode: Phaser.Scale.RESIZE,   // Automatically resize game based on window size
  // },
  // pixelArt: true,
  // transparent: true,
  // physics: {
  //     default: 'arcade',
  //     arcade: {
  //         debug: false
  //     }
  // },
  // scene: [PreloadScene, PlayScene]
  type: Phaser.CANVAS,
  roundPixels: true,
  pixelArt: true,
  scale: {
    // width: 450,
    // height: 640,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    mode: Phaser.Scale.RESIZE
    // mode: Phaser.Scale.HEIGHT_CONTROLS_WIDTH,
  },
  backgroundColor: '#000000',
  physics: {
    default: 'arcade',
    arcade: {
      gravity: {
        y: 0,
        x: 0
      },
      debug: false
    }
  },
  scene: [_bootScene.BootScene, _PreloadScene.default, _GameScene.GameScene]
};
const StartGame = parent => {
  return new _phaser.Game(_objectSpread(_objectSpread({}, config), {}, {
    parent
  }));
};
var _default = exports.default = StartGame;